import * as Sentry from '@sentry/browser';
import { APP_ENVIRONMENT } from 'utils/environment-variables';
import NeurolyticsAPI from './NeurolyticsAPI';

class Logger {
    userId = null;
    groupId = null;

    authenticateLogger(user, groupId) {
        if (user && user.email && user.id && groupId) {
            this.userId = user.id;
            this.groupId = groupId;

            Sentry.configureScope((scope) => {
                scope.setUser({ email: user.email, id: user.id });
                scope.setTag('user-email', user.email);
                scope.setTag('user-id', user.id);
                scope.setTag('group-id', groupId);
            });
        }
    }

    catchComponentError(error, errorInfo) {
        this.logError(
            `ErrorBoundary - Caught an error in a React component`,
            error,
        );
        this.logError(`ErrorBoundary - More info about the error`, errorInfo);

        Sentry.withScope((scope) => {
            scope.setExtras(errorInfo);
            const eventId = Sentry.captureException(error);
            Sentry.showReportDialog({ eventId });
        });
    }

    logInfoOnSentry(message) {
        Sentry.addBreadcrumb({
            message,
            level: 'info',
        });
    }

    log(message) {
        if (APP_ENVIRONMENT !== 'LOCAL' && APP_ENVIRONMENT !== 'TEST') {
            NeurolyticsAPI.sendLog(
                this.userId ? this.userId : 'default',
                this.groupId ? this.groupId : 'default',
                message,
            ).catch((error) => {
                console.log('Failed to log:', message);
                console.log('Error on axios call to send log', error);
            });
        } else {
            console.log(message);
        }
    }

    logInfo(message, context) {
        this.logInfoOnSentry(message);
        const stringContext = context
            ? '- context: ' + JSON.stringify(context)
            : '';
        const logMessage = `[ INFO ] - ${message} ${stringContext}`;
        this.log(logMessage);
    }

    logError(message, error) {
        const stringError = error.message ? error.message : error.toString();
        const logMessage = `[ ERROR ] - ${message} - Error: ${stringError}`;
        this.log(logMessage);
    }

    logWarning(message, context) {
        const stringContext = context
            ? '- context: ' + JSON.stringify(context)
            : '';
        const logMessage = `[ WARNING ] - ${message} ${stringContext}`;
        this.log(logMessage);
    }
}

const instance = new Logger();

export default instance;
